import { select_ui_settings, set_ui_settings, } from 'console/redux/settings-actions';
import { isGeozonesEnabled } from '../lib/enabled';
export function changeShowGeozoneRedactor(show) {
    return set_ui_settings({ map: { show_geozones_redactor: show } });
}
export const getShowGeozones = (state) => (select_ui_settings(state).map?.show_geozones ?? true) && isGeozonesEnabled();
export const getShowGeozonesRedactor = (state) => (select_ui_settings(state).map?.show_geozones_redactor ?? false) &&
    isGeozonesEnabled();
